import { render, staticRenderFns } from "./state-table.vue?vue&type=template&id=2e277624"
import script from "./state-table.vue?vue&type=script&lang=js"
export * from "./state-table.vue?vue&type=script&lang=js"
import style0 from "./state-table.vue?vue&type=style&index=0&id=2e277624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports